import React from "react";
import ConveniosYearPage from "./ConveniosYearPage";
import { convenios2024 } from "../../../../data/Convenios/dataConvenios";

const Convenios2024 = () => <ConveniosYearPage year={2024} data={convenios2024} />;

export default Convenios2024;